import styled from "styled-components";
import { getBreakpoint } from "../../../../themes/common";
import { theme } from "../theme/lexusTheme";
import * as Button from "../components/Button";

export const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;

    ${Button.ButtonPrimary},
    ${/* sc-selector */ Button.ButtonSecondary},
    ${Button.ButtonLightVariantWrapper} {
        justify-content: center;
        max-width: 195px;
        margin: 0 0 ${theme.space[2]}px 0;
        @media ${getBreakpoint("down", "md")} {
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
`;
